import {Component} from '@angular/core';

/**
 * Pure presentation/layout shell for table toolbars.
 * No business logic, actions, permissions, or API knowledge.
 *
 * Projection slots (parent-owned content):
 * - [toolbarLeading]
 * - [toolbarSearch]
 * - [toolbarFilters]
 * - [toolbarTrailing]
 */
@Component({
    selector: 'app-shared-table-toolbar',
    standalone: true,
    templateUrl: './shared-table-toolbar.component.html',
    styleUrl: './shared-table-toolbar.component.css',
})
export class SharedTableToolbarComponent {
}
